/* eslint-disable import/no-anonymous-default-export */
import { object, string, number, array,ref} from "yup";


export default {
    "profile":object().shape({
        user_name:string().required("given name is required"),
        user_details : object().shape({
            given_name:string().required("given name is required"),
            family_name:string().required("family name is required"),
            address:string().required("address is required"),
            email:string().required("email is required"),
            'custom:PINo':string().required("custom:PINo is required")
    
    
            
        })
      }),
    "password":object().shape({
        old_password:string().required("old password is required"),
        new_password:string()
          .required("password is required")
          .min(8, "Password must be at least 8 characters")
          .matches(/[A-Z]/, "Password must include at least 1 uppercase letter")
          .matches(/[a-z]/, "Password must include at least 1 lowercase letter")
          .matches(/[0-9]/, "Password must include at least 1 number")
          .matches(/[^A-Za-z0-9]/, "Password must include at least 1 special character"),
        new_password_confirmation:string().oneOf([ref('new_password')], 'Your passwords do not match.')
    })
}
// export default  object().shape({
//     user_name:string().required("given name is required"),
//     user_details : object().shape({
//         given_name:string().required("given name is required"),
//         family_name:string().required("family name is required"),
//         address:string().required("address is required"),
//         email:string().required("email is required"),
//         'custom:PINo':string().required("custom:PINo is required")


        
//     })
//   });